let quickExamination = [
  {
    path: '/quickExamination',
    name: '快速检查',
    component: () => import('@/pages/quickExamination/index')
  },
  {
    path: '/quickExamination/category',
    name: '快速检查分类',
    component: () => import('@/pages/quickExamination/category')
  },
  {
    path: '/quickExamination/expert',
    name: '快速检查-专家预约',
    component: () => import('@/pages/quickExamination/expert')
  },
  {
    path: '/quickExamination/billing',
    name: '快速检查-门诊检验检查开单',
    component: () => import('@/pages/quickExamination/billing')
  },
  {
    path: '/quickExamination/cart',
    name: '快速检查',
    component: () => import('@/pages/quickExamination/cart')
  },
  {
    path: '/quickExamination/orderConfirm',
    name: '快速检查-订单确认',
    component: () => import('@/pages/quickExamination/orderConfirm')
  },
  {
    path: '/quickExamination/orderList',
    name: '快速检查-订单列表',
    component: () => import('@/pages/quickExamination/orderList')
  },
  {
    path: '/quickExamination/orderDetail',
    name: '快速检查-订单详情',
    component: () => import('@/pages/quickExamination/orderDetail')
  },
  {
    path: '/quickExamination/refund',
    name: '快速检查-退款',
    component: () => import('@/pages/quickExamination/refund')
  }
]

export default quickExamination
